module.exports = __webpack_public_path__ + "img/1502.3bd521dc.gif";